import React from 'react';
import { Link } from 'react-router-dom';
export function ProofCTA() {
  return <section className="py-20 px-4 bg-[#0f1f3d] text-white text-center" data-id="element-653">
      <div className="max-w-3xl mx-auto" data-id="element-654">
        <h2 className="text-3xl sm:text-4xl font-black mb-6" data-id="element-655">
          Ready to write your own success story?
        </h2>
        <p className="text-gray-300 mb-8 text-lg leading-relaxed" data-id="element-656">
          Join the hundreds of families who've discovered what makes NWBBA
          special.
        </p>
        <Link to="/" className="inline-block px-8 py-4 bg-[#dc2626] text-white text-lg font-bold rounded-lg shadow-lg hover:bg-red-700 transition-colors border-2 border-[#a3d977]/30" data-id="element-657">
          Start Your $29 Trial
        </Link>
      </div>
    </section>;
}